import {UserMarketingRules} from "@app/core/user-marketing-rules/domain/user-marketing-rules";
import {UserMarketingRulesDb} from "@app/core/user-marketing-rules/infrastructure/user-marketing-rules-db";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class UserMarketingRulesDbMapper {
    fromEntity(entity: UserMarketingRules): UserMarketingRulesDb {
        const userMarketingRulesPrimitives = entity.toPrimitives();
        return {
            downloadAppMessageClosedAt: userMarketingRulesPrimitives.downloadAppMessageClosedAt,
        }
    }

    toEntity(db: UserMarketingRulesDb): UserMarketingRules {
        return UserMarketingRules.fromPrimitives({
            downloadAppMessageClosedAt: db.downloadAppMessageClosedAt,
        });
    }
}